var map = {
	"./Instyle.png": 760,
	"./allrecipes.png": 5297,
	"./allyou.png": 4467,
	"./betterhomesgardens.png": 41,
	"./business.png": 3181,
	"./coastalliving.png": 8781,
	"./cookinglight.png": 2766,
	"./countrygardens.png": 6990,
	"./diabeticliving.png": 153,
	"./doityourself.png": 3959,
	"./eatingwell.png": 105,
	"./entertainment.png": 5776,
	"./familycircle.png": 8410,
	"./finecooking.png": 7606,
	"./foodwine.png": 1022,
	"./health.png": 6515,
	"./homepage.png": 5833,
	"./homesgardens.png": 9402,
	"./life.png": 4330,
	"./magnolia.png": 5780,
	"./marthastewart.png": 8382,
	"./midwestliving.png": 9795,
	"./millie.png": 3869,
	"./parents.png": 5029,
	"./parentsLatina.png": 9636,
	"./people.png": 6964,
	"./peopleenspanol.png": 8666,
	"./peoplestyle.png": 3097,
	"./rachaelray.png": 2826,
	"./realsimple.png": 3073,
	"./reveal.png": 9293,
	"./shape.png": 3201,
	"./southernliving.png": 6540,
	"./successfulfarming.png": 5794,
	"./traditionalhome.png": 8473,
	"./travelleisure.png": 1062,
	"./wood.png": 4815
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3909;